export default __webpack_public_path__ + "1.18.21/static/media/LibreDataShare.42dcc986.svg";